import { authProvider} from '../authProvider'

export default function useAuthentication() {
  return { account: authProvider.getAccountInfo() }
}

export function passwordChange():void {
  window.location.href=`${process.env.EXPO_AUTH_RESET_PASSWORD}`
}